import React, {Component} from "react";
import {Link} from "react-router-dom";
import {withTranslate} from "react-redux-multilingual"
import {profile} from "../store/actions/userActions";
import {connect} from "react-redux";
import {getHeader, ResendCodeUrl} from "./../config";
import axios from "axios";
import {changeActivationPopUpStatus} from "../store/actions/reservationActions";

class ActivateForm extends Component {
    constructor(props) {
        super(props);
        const token = localStorage.getItem("access_token") ? JSON.parse(localStorage.getItem("access_token")) : null;
        if (token !== null) {
            this.props.profile();
        }
    }
    state = {
        isSuccess: false,
        isError: false,
        resendLoading: false,
        msg: "",
    };
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            msg: nextProps.errorMsgText,
            isError: nextProps.errorMsg
        })
    }


    logout = (e) => {
        e.preventDefault();
        localStorage.clear();
        window.location.href = "/";
    };
    resendCode = (e) => {
        e.preventDefault();
        // start loading
        this.setState({
            resendLoading: true,
        });
        axios.post(ResendCodeUrl, "", {headers: getHeader()}).then(res => {
            // stop loading
            this.setState({
                resendLoading: false,
                msg: res.data.Error.desc,
                isError: true,

            });
            if (res.data.Error.code === 20) {
                this.setState({
                    isSuccess: true,
                })
            }
        }).catch(error => {
            console.log(error);
            this.setState({
                resendLoading: true,
            });
        })
    };

    render() {
        const {translate, onSubmission, handleInputChange, loading, authUser} = this.props;
        return (
            <div className={this.props.fromOtherLink ? "wrap-login100 pop-up-padding" : "wrap-login100"}>
                <a href="/" className="closebtn" hidden={!this.props.fromOtherLink}
                   onClick={(e) => this.props.changeActivationFormStatus(e, "close")}>&times;</a>
                <form onSubmit={onSubmission} className="login100-form validate-form">
                    <a href="/" className="logo-auth" hidden={this.props.fromOtherLink}>
                        <img className={authUser ? "width-100" : null}
                             src={authUser ? authUser.image : "images/logo.png"} alt="seena logo"/>
                    </a>
                    <span className="login100-form-title p-b-59" hidden={this.props.fromOtherLink}>
                            {authUser ? authUser.name : translate('verify_code')}
                        </span>
                    <span id={this.state.isSuccess ? "success-msg" : "error-msg"} className="full-width" hidden={this.state.isError === false}>{this.state.msg}</span>
                    <span id="error-msg" className="full-width" hidden={!this.props.sendCodeErrorMsg || this.props.sendCodeErrorMsg === null}>{this.props.sendCodeErrorMsg}</span>

                    <div className="wrap-input100 validate-input">
                        <input id="pin" type="text" className="form-control input100 curvy-input"
                               onChange={handleInputChange}
                               placeholder="Verification Code" required/>
                    </div>
                    <div className="container-login100-form-btn relative">
                        <button type="submit"
                                className="login100-form-btn btn-block cursor-pointer curvy-input height-45">{translate("submit")}</button>
                        <span id="loading" className="auth-loading"
                              hidden={loading === false}>
                                                    <img style={{width: "30px", height: "30px", marginTop: "15px"}}
                                                         src="/images/loading-white.svg" alt="loading"/>
                                                </span>
                    </div>
                    <div className="text-center link-area full-width">
                        {authUser ?
                            <div>
                                <a href='/'
                                   onClick={(e) => this.resendCode(e)}>{this.props.translate("resend_code")}</a>
                                <span id="loading"
                                      hidden={this.state.resendLoading === false}>
                                                    <img style={{width: "30px", height: "30px", marginTop: "15px"}}
                                                         src="/images/loading.svg" alt="loading"/>
                                                </span>
                                <br/>
                                <a hidden={this.props.fromOtherLink} href='/' onClick={(e) => this.logout(e)}>{this.props.translate("logout")}</a>
                            </div>
                            :
                            <Link to="/"><span>{"<- " + translate("back_to_home")} </span></Link>
                        }
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        authUser: state.user.authUser,
        // for show/hide activation pop up
        activationPopUpStatus: state.reservation.activationPopUpStatus,
    }

};

const mapDispatchToProps = (dispatch) => {
    return {
        profile: () => {
            dispatch(profile())
        },
        // for show/hide activation pop up
        changeActivationPopUpStatus: (status) => dispatch(changeActivationPopUpStatus(status)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(ActivateForm))